export const SET_CATEGORY_ID = 'SET_CATEGORY_ID';
export const REMOVE_CATEGORY_ID = 'REMOVE_CATEGORY_ID';
export const SET_CATEGORIES = 'SET_CATEGORIES';
